import React from 'react';
import { Phone } from 'lucide-react';
import { businessInfo, images } from '../data/mock';

export const Hero = () => {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0">
        <img 
          src={images.hero} 
          alt="Modern car workshop" 
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/90 via-black/80 to-black"></div>
        <div className="absolute inset-0 bg-gradient-to-r from-purple-900/20 to-pink-900/20"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-32 text-center">
        {/* Logo */}
        <div className="flex justify-center mb-8">
          <img 
            src="https://customer-assets.emergentagent.com/job_bilservice-gavle/artifacts/2ug1w9wo_GADEP-Picsart-BackgroundRemover.jpg" 
            alt="Gävles Autodepå" 
            className="h-32 w-auto animate-fade-in"
          />
        </div>

        {/* Main Heading */}
        <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 animate-fade-in-up">
          Din Bil i <span className="text-transparent bg-clip-text bg-gradient-to-r from-purple-400 to-pink-400">Trygga Händer</span>
        </h1>

        {/* Subheading */}
        <p className="text-xl md:text-2xl text-gray-300 mb-12 max-w-3xl mx-auto animate-fade-in-up animation-delay-200">
          Snabb och smidig bilservice med personlig kontakt. 
          Hög kvalitet till bra priser – vi kommer även till dig!
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row gap-6 justify-center items-center animate-fade-in-up animation-delay-400">
          <a 
            href={`tel:${businessInfo.phone}`}
            className="group bg-gradient-to-r from-purple-600 to-pink-600 text-white px-10 py-5 rounded-lg font-bold text-lg flex items-center gap-3 hover:from-purple-700 hover:to-pink-700 transition-all duration-300 shadow-2xl shadow-purple-500/50 hover:shadow-purple-500/70 hover:scale-105"
          >
            <Phone size={24} className="group-hover:rotate-12 transition-transform" />
            Ring Nu: {businessInfo.phone}
          </a>
        </div>

        {/* Email CTA */}
        <div className="mt-6 animate-fade-in-up animation-delay-600">
          <p className="text-gray-400 text-lg">
            eller mejla oss på{' '}
            <a 
              href={`mailto:${businessInfo.email}`}
              className="text-purple-400 hover:text-pink-400 font-semibold underline transition-colors duration-300"
            >
              {businessInfo.email}
            </a>
          </p>
        </div>

        {/* Trust Indicators */}
        <div className="mt-16 flex flex-wrap justify-center gap-8 md:gap-16 text-center animate-fade-in-up animation-delay-600">
          <div>
            <div className="text-4xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-purple-400 to-pink-400 mb-2">5</div>
            <div className="text-gray-400 text-sm uppercase tracking-wider">Års Erfarenhet</div>
          </div>
          <div>
            <div className="text-4xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-purple-400 to-pink-400 mb-2">1000+</div>
            <div className="text-gray-400 text-sm uppercase tracking-wider">Nöjda Kunder</div>
          </div>
          <div>
            <div className="text-4xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-purple-400 to-pink-400 mb-2">5.0</div>
            <div className="text-gray-400 text-sm uppercase tracking-wider">Google Betyg</div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <div className="w-6 h-10 border-2 border-purple-400 rounded-full flex justify-center">
          <div className="w-1 h-3 bg-purple-400 rounded-full mt-2 animate-scroll"></div>
        </div>
      </div>
    </section>
  );
};
